import * as React from 'react';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Icon from 'components/IconDeprecated';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import { DeviceType } from 'auth/components/ConfirmDevice';
import { MouseEventHandler } from 'types/typescript/eventHandlers';
import Image from 'components/Image';
import MagicEmailImage from 'assets/images/magic-email.svg';

export type Props = {
  uid: string;
  deviceType: DeviceType;
  needsPassword: boolean;
  onGoBack?: MouseEventHandler;
  needsConfirmationErrorCode?: string;
};

export default function ConfirmDeviceHeader(props: Props) {
  const getHeading = () => {
    if (deviceType === 'email') {
      return 'Check your email to continue';
    } else {
      return 'Check your phone to continue';
    }
  };

  const getReason = () => {
    const { needsPassword, needsConfirmationErrorCode } = props;
    const confirmText = 'To confirm your account';
    const verifyText = 'To verify it’s you';

    if (needsPassword) {
      return 'Your account doesn’t have a password yet. To set it up';
    } else if (needsConfirmationErrorCode) {
      const codeToReasonMap: Record<string, string> = {
        unconfirmed_contactable_email: confirmText,
        unconfirmed_contactable_phone: confirmText,
        session_login_reconfirm_email: verifyText,
        session_login_reconfirm_phone: verifyText,
        session_login_confirm_email: verifyText,
        session_login_confirm_phone: verifyText,
      };
      return codeToReasonMap[needsConfirmationErrorCode] ?? confirmText;
    }
    return confirmText;
  };

  const { uid, onGoBack, deviceType } = props;
  return (
    <>
      {onGoBack && (
        <Row size="small">
          <Text align="left">
            <Link onClick={onGoBack} eventKey={`log_in.confirm_${deviceType}_page.go_back.click`}>
              <Icon name="arrow-left" />
              {` Back`}
            </Link>
          </Text>
        </Row>
      )}
      <Row size="small">
        <Row size="small">
          <Heading data-test="confirm-device-heading">{getHeading()}</Heading>
        </Row>
        <Row>
          <Image src={MagicEmailImage} />
        </Row>
        <Text color="graphite">
          {`${getReason()}, follow the verification steps sent to `}
          <Text weight="semibold">{uid}</Text>
        </Text>
      </Row>
      <Divider size="medium" />
      <Row>
        <Text color="graphite">Or you can verify by entering the 4-digit code below</Text>
      </Row>
    </>
  );
}
